/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Art_HeadingInputs */

const en_svc_rag_art_heading = /** @type {(inputs: Svc_Rag_Art_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`“How much notice does a cancellation need?”`)
};

const lv_svc_rag_art_heading = /** @type {(inputs: Svc_Rag_Art_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`“Cik savlaicīgi jāpaziņo par atcelšanu?”`)
};

/**
* | output |
* | --- |
* | "“How much notice does a cancellation need?”" |
*
* @param {Svc_Rag_Art_HeadingInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_rag_art_heading = /** @type {((inputs?: Svc_Rag_Art_HeadingInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Art_HeadingInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_rag_art_heading(inputs)
	return en_svc_rag_art_heading(inputs)
});